// extracted by mini-css-extract-plugin
export var alertWidthContraints = "Covid-module--alertWidthContraints--4229d";
export var alertWrap = "Covid-module--alertWrap--35d31";
export var alert_content = "Covid-module--alert_content--d4209";
export var alert_dismissBtn = "Covid-module--alert_dismissBtn--f2dd1";